/* ═══════════════════════════════════════════════════════════════════════
   FizzyIQ — Comparison table. The marks fade in column by column
   (left → right) every time the table scrolls into view, and reset when it
   scrolls out so the animation replays on each re-entry (Sam 2026-06-07).
   The .pcc--anim class is added by JS so that, with JS off, the marks are
   simply visible (no permanent hidden state).
   ═══════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.__fizzyPdpClassicCompareBooted) return;
  window.__fizzyPdpClassicCompareBooted = true;

  function boot() {
    var tables = document.querySelectorAll('.pcc');
    Array.prototype.forEach.call(tables, function (pcc) {
      pcc.classList.add('pcc--anim');
      if (!('IntersectionObserver' in window)) {
        pcc.classList.add('is-revealed');
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            pcc.classList.add('is-revealed');     // play in
          } else {
            pcc.classList.remove('is-revealed');  // reset so it replays next time
          }
        });
      }, { threshold: 0.25 });
      io.observe(pcc);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
